import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _BanksList;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import partial from 'lodash/partial';
import { List } from '@instructure/ui-list';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';
import { Heading } from '@instructure/ui-heading';
import { PresentationContent, ScreenReaderContent } from '@instructure/ui-a11y-content';
import { IconButton } from '@instructure/ui-buttons';
import { IconEditLine, IconTrashLine, IconShareSolid, IconCopyLine } from '@instructure/ui-icons';
import { Alert } from '@instructure/ui-alerts';
import { Spinner } from '@instructure/ui-spinner';
import { Table } from '@instructure/ui-table';
import { jsx } from '@instructure/emotion';
import { EDIT_BANK_MODAL, withI18nSupport, withStyleOverrides } from '@instructure/quiz-common';
import CustomPropTypes from '../../../common/util/CustomPropTypes';
import IfFeature from '../../../common/components/shared/IfFeature';
import EditBankModal from '../EditBankModal';
import SharingModal from '../SharingModal';
import t from '@instructure/quiz-i18n/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var BanksList = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_BanksList = /*#__PURE__*/function (_withI18nSupport) {
  function BanksList() {
    var _this2;
    _classCallCheck(this, BanksList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, BanksList, [].concat(args));
    _defineProperty(_this2, "state", {
      sharingModalOpen: false,
      sharingModalBank: null,
      sharingCount: null,
      countedBank: null
    });
    _defineProperty(_this2, "sharingButtons", []);
    _defineProperty(_this2, "openModal", function (bank) {
      return function () {
        _this2.props.openModal([EDIT_BANK_MODAL, bank.id].join(':'));
      };
    });
    _defineProperty(_this2, "deleteBank", function (bankId) {
      _this2.props.deleteBank(bankId);
      setTimeout(_this2.props.focusCreateBankButton, 100);
    });
    _defineProperty(_this2, "openDeleteBankModal", function (bank) {
      return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2$props, currentUser, getUserInfo, deletingOwnBank, creatorFullName, resp, confirmBody;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2$props = _this2.props, currentUser = _this2$props.currentUser, getUserInfo = _this2$props.getUserInfo;
              deletingOwnBank = currentUser && currentUser.uuid === bank.creator;
              if (deletingOwnBank) {
                _context.next = 7;
                break;
              }
              _context.next = 5;
              return getUserInfo(bank.creator);
            case 5:
              resp = _context.sent;
              creatorFullName = resp && resp[0] && resp[0].fullName;
            case 7:
              confirmBody = jsx("div", null, !deletingOwnBank && (creatorFullName ? t('You are about to delete an Item Bank that you did not create. This Item Bank was created by {creator}, proceed with caution.', {
                creator: creatorFullName
              }) : t('You are about to delete an Item Bank that you did not create. Proceed with caution.')), jsx(Alert, {
                variant: "error",
                padding: "0"
              }, jsx("div", {
                css: _this2.props.styles.deleteAlert
              }, jsx("div", {
                css: _this2.props.styles.deletePreface
              }, t('Once deleted, items from this bank:')), jsx(List, null, jsx(List.Item, null, t('will no longer be accessible to others who currently have shared access')), jsx(List.Item, null, t.rich('will <0>NOT</0> be removed from any assessments', [function (_ref2) {
                var children = _ref2.children;
                return jsx(Text, {
                  weight: "bold",
                  key: "0"
                }, children);
              }])), jsx(List.Item, null, t('will lose their statistical link in reporting (if they were part of an assessment)')), jsx(List.Item, null, t('will no longer be available to any assessments attempting a random/batch pull of items (removing the pull will resolve the issue)'))))));
              _this2.props.withConfirm(partial(_this2.deleteBank, bank.id), {
                text: confirmBody,
                title: t('Delete Bank'),
                continueText: t('Delete'),
                continueVariant: 'danger',
                size: 'medium'
              });
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    });
    _defineProperty(_this2, "openDuplicateBankModal", function (bank) {
      return function () {
        var createCloneJob = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            var cloneJob;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this2.props.createBankCloneJob(bank.id, _this2.props.currentUser.uuid);
                case 2:
                  cloneJob = _context2.sent;
                  _this2.props.addToPolling(cloneJob.cloned_bank_id, t('{name} Copy', {
                    name: bank.title
                  }));
                  _this2.props.addInfo(t('Creating "{name} Copy". Duplicate will appear in \'Shared with Me\' filter.', {
                    name: bank.title
                  }));
                case 5:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          return function createCloneJob() {
            return _ref3.apply(this, arguments);
          };
        }();
        _this2.props.withConfirm(partial(createCloneJob), {
          text: t('Are you sure you want to duplicate this item bank?'),
          title: t('Duplicate Bank'),
          continueText: t('Duplicate'),
          continueVariant: null,
          size: 'small'
        });
      };
    });
    _defineProperty(_this2, "updateSharedCount", function (count) {
      _this2.setState({
        sharingCount: count
      });
    });
    _defineProperty(_this2, "openSharingModal", function (bank) {
      return function () {
        _this2.setState({
          sharingModalOpen: true,
          sharingModalBank: bank,
          sharingCount: bank.sharedCount,
          countedBank: bank.id
        });
      };
    });
    _defineProperty(_this2, "handleSharingModalDismiss", function () {
      _this2.setState({
        sharingModalOpen: false,
        sharingModalBank: null
      });
    });
    _defineProperty(_this2, "handleSharingButtonRef", function (bankId) {
      return function (node) {
        _this2.sharingButtons[bankId] = node;
      };
    });
    _defineProperty(_this2, "currentBankCount", function (bank) {
      var _this2$state = _this2.state,
        countedBank = _this2$state.countedBank,
        sharingCount = _this2$state.sharingCount;
      if (countedBank === bank.id && Number.isInteger(sharingCount)) {
        return sharingCount;
      }
      return bank.sharedCount;
    });
    _defineProperty(_this2, "handleTableRef", function (element) {
      if (element) {
        var simpleSelect = element.querySelector('[role="combobox"]');
        if (simpleSelect) {
          simpleSelect.setAttribute('data-automation', 'sdk-banks-sorting-select');
        }
      }
    });
    _defineProperty(_this2, "renderBankInfo", function (bank) {
      var navigateToBank = function navigateToBank(bankId) {
        return function () {
          return _this2.props.navigateToBank(bankId);
        };
      };
      if (bank.status === 'copying') {
        return jsx("div", {
          css: _this2.props.styles.bankInfo,
          "data-automation": "sdk-bank-info",
          tabIndex: "-1"
        }, jsx("div", {
          css: _this2.props.styles.bankTitle
        }, jsx(Heading, {
          as: "h2",
          level: "reset",
          "data-automation": "sdk-banks-list-bank-title-heading"
        }, bank.title)), jsx("div", {
          css: _this2.props.styles.bankDetails,
          "data-automation": "sdk-banks-list-bank-details"
        }, t('Currently duplicating')));
      } else {
        return jsx("div", {
          css: _this2.props.styles.bankInfo,
          "data-automation": "sdk-bank-info",
          tabIndex: "-1"
        }, jsx("div", {
          css: _this2.props.styles.bankTitle
        }, jsx(Link, {
          onClick: navigateToBank(bank.id),
          themeOverride: {
            color: _this2.props.styles.bankTitleLinkColor,
            hoverColor: _this2.props.styles.bankTitleLinkHoverColor
          },
          "data-automation": "sdk-banks-list-bank-title-link"
        }, jsx(Heading, {
          as: "h2",
          level: "reset",
          "data-automation": "sdk-banks-list-bank-title-heading"
        }, bank.title))), _this2.renderDetails(bank));
      }
    });
    _defineProperty(_this2, "renderBankOptions", function (bank) {
      var bankEditOptions = jsx(React.Fragment, null, jsx(IconButton, {
        onClick: _this2.openModal(bank),
        name: "Edit",
        size: "small",
        "data-automation": "sdk-edit-bank-button",
        withBackground: false,
        withBorder: false,
        renderIcon: IconEditLine,
        title: t('Edit bank {name}', {
          name: bank.title
        }),
        screenReaderLabel: t('Edit bank {name}', {
          name: bank.title
        })
      }), jsx(IconButton, {
        onClick: _this2.openDeleteBankModal(bank),
        name: "Delete",
        size: "small",
        "data-automation": "sdk-delete-bank-button",
        withBackground: false,
        withBorder: false,
        renderIcon: IconTrashLine,
        title: t('Delete bank {name}', {
          name: bank.title
        }),
        screenReaderLabel: t('Delete bank {name}', {
          name: bank.title
        })
      }));
      if (bank.status === 'copying') {
        return jsx("div", {
          css: _this2.props.styles.bankOptions
        }, t('Duplicating'), jsx(Spinner, {
          renderTitle: t('Loading'),
          size: "x-small",
          margin: "0 0 0 small"
        }));
      } else {
        return jsx("div", {
          css: _this2.props.styles.bankOptions
        }, jsx(IconButton, {
          onClick: _this2.openDuplicateBankModal(bank),
          name: "Duplicate",
          size: "small",
          "data-automation": "sdk-duplicate-bank-button",
          renderIcon: IconCopyLine,
          withBackground: false,
          withBorder: false,
          title: t('Duplicate bank {name}', {
            name: bank.title
          }),
          screenReaderLabel: t('Duplicate bank {name}', {
            name: bank.title
          })
        }), jsx(IfFeature, {
          name: "item_bank_sharing"
        }, jsx(IconButton, {
          onClick: _this2.openSharingModal(bank),
          name: "Share",
          size: "small",
          "data-automation": "sdk-shared-bank-share-link",
          withBackground: false,
          withBorder: false,
          renderIcon: IconShareSolid,
          title: t('Share bank {name}', {
            name: bank.title
          }),
          screenReaderLabel: t('Share bank {name}', {
            name: bank.title
          })
        })), bank.canEdit() ? bankEditOptions : null);
      }
    });
    _defineProperty(_this2, "renderBank", function (bank) {
      return jsx("div", {
        key: bank.id,
        css: _this2.props.styles.bankRow,
        "data-automation": "sdk-banks-list-bank-row"
      }, jsx(EditBankModal, {
        workingBank: bank.getWorkingInstance()
      }), _this2.renderBankInfo(bank), _this2.renderBankOptions(bank));
    });
    return _this2;
  }
  _inherits(BanksList, _withI18nSupport);
  return _createClass(BanksList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;
      if (this.state.sharingModalBank) {
        var bankFromList = this.props.banks.find(function (bank) {
          return bank.get('id') === _this3.state.sharingModalBank.get('id');
        });
        if (!this.state.sharingModalBank.equals(bankFromList)) {
          this.setState({
            sharingModalBank: bankFromList
          });
        }
      }
    }
  }, {
    key: "renderDetails",
    value: function renderDetails(bank) {
      var separator = ' | ';
      var lastUsedInfo = bank.lastUsed() && jsx(React.Fragment, null, jsx(PresentationContent, null, separator), t('Last used { lastUsedDate }', {
        lastUsedDate: this.formatDateMedium(bank.lastUsed())
      }));
      return jsx("div", {
        css: this.props.styles.bankDetails,
        "data-automation": "sdk-banks-list-bank-details"
      }, jsx("div", null, t('Updated { updatedDate }', {
        updatedDate: this.formatDateMedium(bank.updatedAt())
      }), jsx(PresentationContent, null, separator), t("{\n              count, plural,\n              one {# Question Total}\n              other {# Questions Total}\n            }", {
        count: bank.itemEntryCount
      }), lastUsedInfo));
    }
  }, {
    key: "renderSharingModal",
    value: function renderSharingModal() {
      return jsx(SharingModal, {
        appContainer: this.props.appContainer,
        bank: this.state.sharingModalBank,
        currentUser: this.props.currentUser,
        focusCreateBankButton: this.props.focusCreateBankButton,
        getCourseInfo: this.props.getCourseInfo,
        getUserInfo: this.props.getUserInfo,
        getSubaccountInfo: this.props.getSubaccountInfo,
        isOpen: this.state.sharingModalOpen,
        minChars: this.props.minChars,
        modalTrigger: this.sharingButtons[this.state.sharingModalBank.id],
        onDismiss: this.handleSharingModalDismiss,
        onShare: this.props.onShare,
        getShareableCourses: this.props.getShareableCourses,
        getShareableUsers: this.props.getShareableUsers,
        getShareableSubaccounts: this.props.getShareableSubaccounts,
        updateSharedCount: this.updateSharedCount
      });
    }
  }, {
    key: "renderTableRowHeader",
    value: function renderTableRowHeader(bank) {
      var _this4 = this;
      if (bank.status === 'copying') {
        return jsx(Table.RowHeader, null, jsx("div", {
          css: this.props.styles.rowHeader
        }, jsx(Heading, {
          as: "h2",
          level: "reset",
          "data-automation": "sdk-banks-list-bank-title-heading"
        }, bank.title), this.props.isCompact && this.renderBankOptions(bank)));
      } else {
        var navigateToBank = function navigateToBank(bankId) {
          return function () {
            return _this4.props.navigateToBank(bankId);
          };
        };
        return jsx(Table.RowHeader, null, jsx("div", {
          css: this.props.styles.rowHeader
        }, jsx(EditBankModal, {
          workingBank: bank.getWorkingInstance()
        }), jsx(Link, {
          isWithinText: false,
          onClick: navigateToBank(bank.id),
          "data-automation": "sdk-banks-list-bank-title-link"
        }, jsx(Heading, {
          as: "h2",
          level: "reset",
          "data-automation": "sdk-banks-list-bank-title-heading"
        }, bank.title)), this.props.isCompact && this.renderBankOptions(bank)));
      }
    }
  }, {
    key: "renderTableRow",
    value: function renderTableRow(bank) {
      if (bank.status === 'copying') {
        return jsx(Table.Row, {
          key: bank.id
        }, this.renderTableRowHeader(bank), jsx(Table.Cell, null), jsx(Table.Cell, null), jsx(Table.Cell, null), jsx(Table.Cell, null), !this.props.isCompact && jsx(Table.Cell, {
          textAlign: "end"
        }, this.renderBankOptions(bank)));
      } else {
        return jsx(Table.Row, {
          key: bank.id
        }, this.renderTableRowHeader(bank), jsx(Table.Cell, null, this.formatDateMedium(bank.updatedAt())), jsx(Table.Cell, null, bank.itemEntryCount), jsx(Table.Cell, null, bank.lastUsed() ? this.formatDateMedium(bank.lastUsed()) : ''), jsx(Table.Cell, null, this.formatDateMedium(bank.createdAt())), !this.props.isCompact && jsx(Table.Cell, {
          textAlign: "end"
        }, this.renderBankOptions(bank)));
      }
    }
  }, {
    key: "renderTableSortHeader",
    value: function renderTableSortHeader(headerId, headerText) {
      return jsx(Table.ColHeader, {
        id: headerId,
        key: headerId,
        stackedSortByLabel: headerText,
        onRequestSort: this.props.onChangeSort(headerId, this.props.order),
        sortDirection: this.props.sort === headerId ? this.props.order : 'none'
      }, headerText);
    }
  }, {
    key: "renderTable",
    value: function renderTable() {
      var _this5 = this;
      return jsx(Table, {
        margin: "small 0",
        caption: t('Banks'),
        layout: this.props.isCompact ? 'stacked' : 'auto',
        elementRef: this.handleTableRef
      }, jsx(Table.Head, {
        renderSortLabel: t('Sort By')
      }, jsx(Table.Row, null, this.renderTableSortHeader('name', t('Name')), this.renderTableSortHeader('updated_at', t('Updated')), jsx(Table.ColHeader, {
        id: "header-num-questions",
        width: "1"
      }, t('Questions')), this.renderTableSortHeader('last_used', t('Last Used')), this.renderTableSortHeader('created_at', t('Created')), jsx(Table.ColHeader, {
        id: "header-option-links",
        width: "1"
      }, jsx(ScreenReaderContent, null, t('Bank option links'))))), jsx(Table.Body, null, (this.props.banks.toArray() || []).map(function (bank) {
        return _this5.renderTableRow(bank);
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", null, this.state.sharingModalBank && this.renderSharingModal(), this.props.itemBankSearchTableEnabled ? this.renderTable() : this.props.banks.toArray().map(this.renderBank));
    }
  }]);
}(withI18nSupport(Component)), _defineProperty(_BanksList, "displayName", 'BanksList'), _defineProperty(_BanksList, "componentId", "Quizzes".concat(_BanksList.displayName)), _defineProperty(_BanksList, "propTypes", {
  addInfo: PropTypes.func.isRequired,
  addToPolling: PropTypes.func.isRequired,
  appContainer: CustomPropTypes.selectors.isRequired,
  banks: ImmutablePropTypes.list.isRequired,
  createBankCloneJob: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    bank_admin: PropTypes.bool,
    can_share_banks_with_subaccounts: PropTypes.bool,
    email: PropTypes.string,
    enrollment_names: PropTypes.arrayOf(PropTypes.string),
    full_name: PropTypes.string,
    uuid: PropTypes.string,
    account_name: PropTypes.string
  }),
  focusCreateBankButton: PropTypes.func.isRequired,
  deleteBank: PropTypes.func.isRequired,
  getCourseInfo: PropTypes.func,
  getUserInfo: PropTypes.func,
  getShareableCourses: PropTypes.func,
  getShareableUsers: PropTypes.func,
  getShareableSubaccounts: PropTypes.func,
  minChars: PropTypes.number,
  navigateToBank: PropTypes.func.isRequired,
  onShare: PropTypes.func,
  openModal: PropTypes.func.isRequired,
  withConfirm: PropTypes.func.isRequired,
  locale: PropTypes.string,
  timezone: PropTypes.string,
  styles: PropTypes.object
}), _defineProperty(_BanksList, "defaultProps", {
  currentUser: null,
  getCourseInfo: null,
  getUserInfo: null,
  getShareableCourses: null,
  getShareableUsers: null,
  getShareableSubaccounts: null,
  minChars: void 0,
  locale: null,
  timezone: null,
  onShare: function onShare() {}
}), _defineProperty(_BanksList, "contextTypes", {
  locale: PropTypes.string,
  timezone: PropTypes.string
}), _BanksList)) || _class);
export default BanksList;